import get from 'lodash/get';
import forEach from 'lodash/forEach';
import { CONNECTION_CATEGORY_TEMPLATIZED_API } from 'js/constants/connectionCategories';
import assign from 'lodash/assign';
import map from 'lodash/map';
import clone from 'lodash/clone';
import { useSelector } from 'react-redux';
import { getCredentialsByType } from 'js/reducers/selectors';

const CREDS_WITHOUT_ID = 'nex-def-val';

export default function useConnectionCredentials(connectionType: string) {
  const allDataCredentials = useSelector(getCredentialsByType);
  const connectionMetas = useSelector((state: any) => state.paging.metaInfoById);

  let credentialsToDisplay = [];
  if (allDataCredentials) {
    let credsForConn = allDataCredentials[connectionType];
    let sortedIds = get(credsForConn, 'sortedIds', []);
    let credsById = get(credsForConn, 'items', {});

    forEach(connectionMetas, (meta, connection) => {
      if (
        meta.connectionCategory === CONNECTION_CATEGORY_TEMPLATIZED_API &&
        meta.connectionType === connectionType
      ) {
        let vendorCreds = allDataCredentials[connection];
        let vendorSortedIds = get(vendorCreds, 'sortedIds', []);
        let vendorCredsById = get(vendorCreds, 'items', {});

        sortedIds = sortedIds.concat(vendorSortedIds);
        credsById = assign({}, credsById, vendorCredsById);
      }
    });

    credentialsToDisplay = map(sortedIds, (cId) => {
      let cred = clone(credsById[cId]);
      cred.value = cred.id || CREDS_WITHOUT_ID;
      cred.label = cred.name || 'Untitled Credential';
      return cred;
    });
  }

  return credentialsToDisplay;
}
